module.exports = __webpack_public_path__ + "static/media/faucet-drip.498c4151.svg";